import { render, staticRenderFns } from "./subscriptions-container.vue?vue&type=template&id=720a78e4"
import script from "./subscriptions-container.vue?vue&type=script&lang=ts"
export * from "./subscriptions-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports